module.exports = {
      id: "textsms-usage",
      viewBox: "0 0 28.57 28.57",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#textsms",
      toString: function () {
        return this.url;
      }
    }